import { useState, useCallback } from 'react';

/**
 * Custom hook for managing notification state and actions
 * @returns {Object} notification state and control functions
 */
export const useNotification = () => {
	const [notification, setNotification] = useState(null);

	const showNotification = useCallback(
		(message, severity = 'info', duration = 6000) => {
			setNotification({ message, severity, duration });
		},
		[]
	);

	const hideNotification = useCallback(() => {
		setNotification(null);
	}, []);

	return {
		notification,
		showNotification,
		hideNotification,
	};
};

